import { TicketRepository } from '../repositories/TicketRepository'

export function ListNotificationsAreasCase(ticketRepository: TicketRepository) {
  return async function () {
    return await ticketRepository.listNotificationsAreas()
  }
}
